<template>
  <div class="right-container-allert">
    <div class="person-bio-container up-person-bio-container person-bio-container-profile">
      <div class="row bio-header up-bio-header">
        <div class="col">
          <div class="avatar-image">
            <user-photo :user="user" v-if="!selectedFile" />
            <img :src="selectedFile" alt="" v-else>
            <input type="file" @change="onFileChanged">
          </div>
        </div>
        <div class="col bio-status">
        </div>
      </div>
      <small class="bio-container up-bio-container">Please click on the image to select a new photo</small>
      <div class="bio-container up-bio-container">
        <div class="bio-info up-bio-info-id" v-if="user && user.id">
          <p>ID</p>
          <p>{{ user.id }}</p>
        </div>
        <div class="bio-info">
          <p>First Name</p>
          <input type="text" v-model="user.first_name">
        </div>
        <div class="bio-info">
          <p>Last Name</p>
          <input type="text" v-model="user.last_name">
        </div>
        <div class="bio-info">
          <p>Email</p>
          <input type="text" v-model="user.mail">
        </div>
        <div class="bio-info" v-if="page == 'MyProfile'">
          <p>Old Password</p>
          <input type="password" value="" v-model="user.old_key">
        </div>
        <div class="bio-info" v-if="page == 'MyProfile'">
          <p>New Password</p>
          <input type="password" value="" v-model="user.new_key">
        </div>
        <div class="bio-info" v-if="['UserProfile', 'AddUserProfile'].includes(page)">
          <p>Password</p>
          <input type="password" value="" v-model="user.key">
        </div>
        <div class="bio-info" v-if="!['StudentProfile', 'AddStudentProfile'].includes(page)">
          <p>Confirm Password</p>
          <input type="password" value="" v-model="user.confirm_key">
        </div>
        <div class="bio-info up-bio-info-role" v-if="['UserProfile', 'AddUserProfile', 'StudentProfile', 'AddStudentProfile'].includes(page)">
          <p>Role</p>
          <div class="dropdown up-dropdown" style="float:left;">
            <button class="dropbtn attendance-dropdown">
              <p>
                <span v-text="roles[currentUser.type]" v-if="roles[currentUser.type]"></span>
                <span v-else>Select...</span>
                &nbsp;
                <i class="fas fa-caret-down"></i></p>
            </button>
            <div class="dropdown-content">
              <a href="#" v-for="(role, key) in roles" :key="key" @click="updateUserRole(key)">{{ role }}</a>
            </div>
          </div>
        </div>
        <div class="bio-info up-bio-info-last-action" v-if="user && user.last_auth">
          <p v-if="page != 'StudentProfile'">Last Action</p>
          <p v-if="page == 'StudentProfile'">Last Seen</p>
          <p>{{ user.last_auth }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import UserPhoto from '@/components/users/Photo';

  export default {
    name: 'ProfileComponent',
    components: {
      UserPhoto
    },
    props: {
      user: {
        type: Object,
        default () {
          return {
            first_name: '',
            last_name: '',
            mail: '',
            key: '',
            old_key: '',
            new_key: '',
            confirm_key: '',
            type: 1,
          }
        }
      },
      page: '',
    },
    data() {
      return {
        currentUser: this.user,
        selectedFile: null,
      };
    },
    computed: {
      roles() {
        let roles = this.$store.state.settings.data.user_types;

        if (['StudentProfile', 'AddStudentProfile'].includes(this.page)) {
          let filters = {};

          filters[5] = roles[5];
          filters[6] = roles[6];

          return filters;
        }

        return roles;
      }
    },
    watch: {
      user(oldUser, newUser) {
        if (oldUser.id != newUser.id) {
          this.selectedFile = null;
        }
      }
    },
    methods: {
      updateUserRole(roleId) {
        this.$set(this.currentUser, 'type', roleId);
      },
      onFileChanged(event) {
        const img = event.target.files[0];

        if (img !== undefined) {
          this.selectedFile = URL.createObjectURL(img);
          this.$emit('update', img);
        }
      },
    }
  };
</script>

<style scoped>
  .avatar-image input {
    height: 130px;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
  }
  .right-container-allert {
    overflow-y: auto;
    height: 87vh;
  }
  .person-bio-container {
    height: auto;
    min-height: 100%;
  }
  .up-bio-info-last-action {
    margin-bottom: 20px;
  }
</style>
